export default class CategorySectionComponent extends HTMLElement {

    constructor({id, className, style, index} = {}) {
        super();
        
        if (!id) {
            throw new Error("Id is required");
        }

        this.id = id;
        this.className = className || "";
        this.style = style || "";
        this.index = index || "";

        this.innerHTML = `
        <div class="${this.className}" style="${this.style}">
            <label></label>
            <div></div>
        </div>
        `;
    }

    setLabel(text, className = null) {

        const labelRef = this.querySelector(`div > label`);
        if (!labelRef) {
            console.error("Label not found");
            return;
        }

        labelRef.innerHTML = text;

        if (className) {
            labelRef.className = className;
        }
    }

    //override appendChild so that children is added to correct container
    appendChild(child) {
        return this.querySelector(`div > div`).appendChild(child);
    }

    show(val) {
        val ? this.classList.remove("hide") : this.classList.add("hide");
    }
}